import React, { ReactElement } from "react";

import Toolbar from "../../toolbar";

import classNames from "classnames";

import {
  historyItemCSS,
  historyItemToolbarCSS,
} from "./ChatHistoryPanelItem.styles";
import { ChatHistoryPanelItemProps } from "./ChatHistoryPanelItem.types";
import { ToolbarItem } from "../../toolbar/components/toolbar-item";

export const ChatHistoryPanelItem = ({
  chatSession,
  className,
  active,
  isFavoritesFull,
  onChatSessionClick,
  onAddFavoriteChatSessionHandler,
  onRenameChatSessionHandler,
  onDeleteChatSessionHandler,
}: ChatHistoryPanelItemProps): ReactElement => {
  const { sessionId, sessionName, isPinned } = chatSession;

  return (
    <div className={className} style={{ display: "flex", gap: 8 }}>
      <button
        type="button"
        className={classNames(historyItemCSS, {
          active,
        })}
        title={sessionName}
        onClick={(): void => onChatSessionClick(sessionId)}
      >
        <span className="chat-history-button-label">{sessionName}</span>
        <div
          className={historyItemToolbarCSS}
          onClick={(e): void => e.stopPropagation()}
        >
          <Toolbar>
            <ToolbarItem
              label={isPinned ? "Remove from favorites" : "Add to favorites"}
              icon="star"
              onClick={(): void =>
                onAddFavoriteChatSessionHandler(sessionId, isPinned)
              }
              disabled={!isPinned && isFavoritesFull}
            />
            <ToolbarItem
              label="Rename"
              icon="pencil"
              onClick={(): void => onRenameChatSessionHandler(chatSession)}
            />
            <ToolbarItem
              label="Delete"
              icon="trash"
              onClick={(): void => onDeleteChatSessionHandler(chatSession)}
            />
          </Toolbar>
        </div>
      </button>
    </div>
  );
};
